export default __webpack_public_path__ + "52e380ccb38be77012b4b58fffbfac21.svg";